import { url } from './url';
/**
 * Стартовая страница роли.
 *
 * Решается в двух местах — в `Router` (вход по форме) и в `CheckTokenPage`
 * (вход из портала по токену), — и раньше они расходились: роутер вёл
 * студента на дашборд, а токен по-прежнему на расписание. Поэтому выбор
 * вынесен сюда: место одно, разойтись нечему.
 *
 * Преподаватель попадает на «Сегодня», остальные — на свой дашборд:
 * деканату сводка по вузу, студенту по его посещаемости. У преподавателя
 * рабочий день начинается с пар, и отметки ставятся оттуда; сводка ему
 * нужна реже и лежит в одном нажатии.
 *
 * Роль важнее деканатского права: у сотрудника с ролью преподавателя
 * может быть доступ и к деканатскому разделу, и раньше он попадал
 * туда. Теперь нет — он всё-таки ведёт пары.
 *
 * `canDekanat` передаётся отдельным признаком, а не выводится из роли:
 * деканатский раздел закрывается лицензией вуза, и без неё маршрута
 * `/dekanat/dashboard` в приложении нет. Отправить туда — значит отправить
 * в никуда, а если бы туда же вёл и запасной адрес, переадресация
 * замкнулась бы.
 */
export const homePath = ({ isStudent, isTeacher, canDekanat }) => {
    if (isStudent)
        return `${url}/student/dashboard`;
    if (isTeacher)
        return `${url}/schedule`;
    if (canDekanat)
        return `${url}/dekanat/dashboard`;
    return `${url}/schedule/dashboard`;
};
